// extracted by mini-css-extract-plugin
export default {"productsTable":"products-table_productsTable__fYvzV","sortIcons":"products-table_sortIcons__zJo+j","cell":"products-table_cell__ZFXyQ","content":"products-table_content__+oCXZ"};